/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { renderNotificationLabel } from 'domain/notifications/Services';

const NotificationItem = ({
  handleOnClickNews,
  isExpanded,
  data: {
    id,
    title,
    detail,
    date_from: date,
    display_notification_type: displayNotificationType,
  },
  isNew,
}) => {
  return (
    <div className={`notification__content ${isNew ? 'font-weight-bold' : ''}`}>
      <div className="d-flex align-items-center notification-date-wrapper">
        <span className="notification-date">
          {date ? moment(date).format('YYYY/MM/DD') : ''}
        </span>
        {renderNotificationLabel(displayNotificationType, false)}
      </div>
      <div
        className={`notification-title ${
          !isExpanded ? 'text--truncate-two-lines' : ''
        }`}
      >
        {title}
        <br />
        <br />
        {isExpanded && <div dangerouslySetInnerHTML={{ __html: detail }} />}
      </div>
      <Button
        variant="link"
        size="sm"
        className="notification-date-button"
        onClick={() => handleOnClickNews(id)}
      >
        詳細を確認する
      </Button>
    </div>
  );
};

NotificationItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    detail: PropTypes.string.isRequired,
    date_from: PropTypes.string.isRequired,
    display_notification_type: PropTypes.string.isRequired,
  }).isRequired,
  handleOnClickNews: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isNew: PropTypes.bool.isRequired,
};

export default React.memo(NotificationItem);
